/**
 * PAPPO — Socket.IO client singleton
 * Conexão WebSocket com o backend Flask-SocketIO.
 * Reconecta automaticamente com JWT.
 */

import { io, Socket } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'http://localhost:5000';

let socket: Socket | null = null;

/**
 * Retorna a instância singleton do socket.
 * Cria a conexão na primeira chamada.
 */
export function getSocket(): Socket {
  if (socket) return socket;

  const token = localStorage.getItem('pappo_access_token');

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on('connect', () => {
    console.log('[PAPPO Socket] Conectado:', socket?.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('[PAPPO Socket] Desconectado:', reason);
  });

  socket.on('connect_error', (err) => {
    console.error('[PAPPO Socket] Erro de conexão:', err.message);
  });

  return socket;
}

/**
 * Desconecta e limpa o socket
 */
export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

/**
 * Reconecta com novo token (ex: após refresh)
 */
export function reconnectSocket(): void {
  disconnectSocket();
  getSocket();
}
